import createResource from './createResource';
import { Upload } from './types';

const uploadsResource = createResource<Upload>({
  key: 'uploads',
  url: '/uploads',
});

export default uploadsResource;
